"use strict";

var formValidation = require("../components/formValidation");
var utilsServices = require ("../utils/utilsServices");
var loyaltyAccount = require("../account/loyaltyAccount");
var utilMask = require ("../utils/masks");
var gtm = require("../gtm");
const recaptchaUtils = require("../utils/recaptchaUtils");

const showErrorEmailRegistered = () => {
    const $notification = $(".notification-alert");
    const messageHasSameEmail = $("#hasCustomerWithSameEmail").attr("message");

    utilsServices.createErrorNotification(messageHasSameEmail, $notification);
};

const listenEventsForm = () => {
    $(".form-rut-field").add("#sociallogin-form-rut").on("keydown", (e) => {
        utilMask.maskRUT(e.target);
    });

    $("#registration-form-birthdate").on("keydown", (e) => {
        utilMask.maskBirthdate(e.target);
    });

    $("#registration-form-phone").add("#sociallogin-form-phone").on("keydown", (e) => {
        utilMask.maskPhone(e.target);
    });

    $(".login-form-nav [data-toggle='tab']").on("shown.bs.tab", (event) => {
        const $tab = $(event.currentTarget);
        const $title = $tab.closest(".login-form-nav").find(".login-title");
        const title = $tab.attr("href") === "#register"
            ? $title.data("register-title")
            : $title.data("login-title");

        $title.text(title);
    });

};

/**
* Handles the login form button
* @param {Object} button - The button element
* @param {boolean} disabled - Whether the button should be disabled or not
*/
const handleLoginFormButton = (button, disabled) => {
    button.prop("disabled", disabled);
};

async function modalClub(loyaltyClubNo, rut, redirect) {
    await loyaltyAccount.loyaltyModel(loyaltyClubNo, rut, redirect);
}

function toggleRule(selector, isValid) {
    $(selector).toggleClass("valid", isValid);
}

function checkPassword(value) {
    const isLengthValid = value.length >= 7;
    const hasUppercase = /[A-ZÑ]/.test(value);
    const hasLowercase = /[a-zñ]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    // Consider 'ñ' and 'Ñ' as normal letters, not special characters - as requested per Ahumada team
    const hasSpecial = /[^A-Za-z0-9ñÑ]/.test(value);

    toggleRule(".rule-length", isLengthValid);
    toggleRule(".rule-uppercase", hasUppercase);
    toggleRule(".rule-lowercase", hasLowercase);
    toggleRule(".rule-number", hasNumber);
    toggleRule(".rule-special", hasSpecial);

    return isLengthValid && hasUppercase && hasLowercase && hasNumber && hasSpecial;
}

module.exports = {
    initialize: function () {
        const showModal = $("#isShowRegisterCustomerModal").val();
        const hasCustomerWithSameEmail = $("#hasCustomerWithSameEmail").val();

        if (showModal === "true") {
            $("#linkOpenRegisterCustomerModal").trigger("click");
        }

        if (hasCustomerWithSameEmail === "true") {
            showErrorEmailRegistered();
        }

        utilMask.maskRUT($(".form-rut-field"));

        listenEventsForm();
    },

    login: function () {

        $(document).ready(function () {
            // change type of password fields to text to prevent loosing users saved passwords if we start with type text
            $(".password-field:not(.start-hidden)").one("input", function () {
                $(this).attr("type", "text");
            });

            var $field = $(".password-field").first();

            if ($field.length && $field.val()) {
                var value = $field.val();

                checkPassword(value);
            }

            $(".toggle-password").on("click", function () {
                const $icon = $(this);
                const $input = $icon.siblings("input.password-field");

                const isText = $input.attr("type") === "text";
                $input.attr("type", isText ? "password" : "text");

                $icon.toggleClass("fa-eye fa-eye-slash");
            });

            $(".password-field-validator").on("input", function () {
                const value = $(this).val();

                checkPassword(value);
            });
        });

        $("form.login").submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr("action");
            const loginButton = form.find(".btn-submit-login");
            const recaptchaSettings = recaptchaUtils.getGRecaptchaConfigurationObject();
            const isRecaptchaEnabled = recaptchaSettings.isEnabled && $(".grecaptcha-container").children().length > 0;
            form.spinner().start();
            $("form.login").trigger("login:submit", e);
            handleLoginFormButton(loginButton, true);

            const callback = function () {
                $.ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    data: form.serialize(),
                    success: function (data) {
                        if (!data.success) {
                            recaptchaUtils.resetGRecaptcha();
                            formValidation(form, data);
                            handleLoginFormButton(loginButton, isRecaptchaEnabled);
                            form.spinner().stop();
                        } else {
                            $("form.login").trigger("login:success", data);
                            const urlRedirect = data.redirectUrl ? data.redirectUrl : $("#url-redirect-to-account-show").val();

                            // Exclusion for mejora 7 - Redirect to cart - 14/07/25
                            // location.href = urlRedirect;
                            location.href = data.redirectUrl;
                        }
                    },
                    error: function (data) {
                        if (data.responseJSON.redirectUrl) {
                            window.location.href = data.responseJSON.redirectUrl;
                        } else {
                            recaptchaUtils.resetGRecaptcha();
                            form.spinner().stop();
                            formValidation(form, data);
                            handleLoginFormButton(loginButton, isRecaptchaEnabled);
                            form.spinner().stop();
                        }
                    }
                });
                return false;
            };

            try {
                recaptchaUtils.renderGRecaptchaIfRequired(callback);
            } catch (e) {
                $.spinner().stop();
            }
        });
    },

    register: async function () {
        const submit = (e) => {
            e.preventDefault();
            const $form = $(e.target).closest("form");
            const isValid = $form[0].checkValidity();
            const $emailInput = $("#registration-form-email");
            const emailAlreadyInUseErrorMsg = $emailInput.data("already-in-use-email");
            const $rutInput = $("#registration-form-rut");
            const rutAlreadyInUseErrorMsg = $rutInput.data("already-in-use-rut");
            const $passwordField = $form.find(".password-field").first();

            if ($passwordField.length && $passwordField.val()) {
                var passwordValue = $passwordField.val();

                if (!checkPassword(passwordValue)) {
                    return;
                }
            }

            if (!isValid) {
                return;
            }

            $.spinner().start();
            const url = $form.attr("action");
            const $notification = $(".notification-alert");

            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: $form.serialize(),
                success: async function (data) {
                    $.spinner().stop();
                    if (!data.success) {

                        if (data.hasCustomerWithSameEmail) {
                            $emailInput.addClass("is-invalid");
                            $emailInput.siblings(".invalid-feedback").text(emailAlreadyInUseErrorMsg);

                            return;
                        }
                        if (data.hasCustomerWithSameRUT) {
                            $rutInput.addClass("is-invalid");
                            $rutInput.siblings(".invalid-feedback").text(rutAlreadyInUseErrorMsg);

                            return;
                        }

                        formValidation($form, data);
                    } else {
                        gtm.gtmSignUp();
                        if (data.club) {
                            await modalClub("11001", data.rut, data.redirectUrl);
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $.spinner().stop();
                        utilsServices.createErrorNotification(data.responseJSON.errorMessage, $notification);
                    }
                }
            });
        };

        $(".registration .submit-btn-form").on("click",  (e) => {
            submit(e);
        });
    },

    resetPassword: function () {
        $(".reset-password-form").submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr("action");
            form.spinner().start();
            $(".reset-password-form").trigger("login:register", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $(".request-password-title").text(data.receivedMsgHeading);
                        $(".request-password-body").empty()
                            .append("<p>" + data.receivedMsgBody + "</p>");
                        if (!data.mobile) {
                            $("#submitEmailButton").text(data.buttonText)
                                .attr("data-dismiss", "modal");
                        } else {
                            $(".send-email-btn").empty()
                                .html("<a href=\""
                                    + data.returnUrl
                                    + "\" class=\"btn btn-primary btn-block\">"
                                    + data.buttonText + "</a>"
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $("#login .modal").on("hidden.bs.modal", function () {
            $("#reset-password-email").val("");
            $(".modal-dialog .form-control.is-invalid").removeClass("is-invalid");
        });
    },

    submitSocialLoginForm: function () {
        const submit = (e) => {
            e.preventDefault();
            const $form = $(e.target).closest("form");
            const isValid = $form[0].checkValidity();

            if (!isValid) {
                return;
            }

            $.spinner().start();
            const url = $form.attr("action");
            const $notification = $(".notification-alert");

            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();

                    if (!data.success) {
                        if (data.hasCustomerWithSameEmail) {
                            showErrorEmailRegistered();
                            return;
                        }

                        formValidation($form, data);
                    } else {
                        const urlRedirect = $("#url-redirect-to-account-show").attr("value");
                        location.href = urlRedirect;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $form.spinner().stop();
                        utilsServices.createErrorNotification(data.responseJSON.errorMessage, $notification);
                    }
                }
            });
        };

        $("#sociallogin-btn").on("click", (e) => {
            submit(e);
        });
    },
};
